module.exports = __webpack_public_path__ + "static/img/Zhangjiakou.1c8c60c5.jpg";